// extracted by mini-css-extract-plugin
export default {"icon":"OverviewLegendTitle_icon__DDBRY","periodText":"OverviewLegendTitle_periodText__Nhz1S"};